import { GoTrueClient } from '@supabase/gotrue-js';
export class SupabaseAuthClient extends GoTrueClient {
    constructor(options) {
        super(options);
    }
}
//# sourceMappingURL=SupabaseAuthClient.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@supabase/supabase-js/dist/module/lib/SupabaseAuthClient.js
// module id = null
// module chunks = 